import React, { useContext } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { ModalContext } from 'App';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { get, getJson } from 'session';
import Pagination from 'modules/common/components/Pagination';
import CreateModal from '../component/CreateModal';
import ViewBusinessLinesModal from './ViewBusinessLinesModal';
import * as actions from '../../../action';
import * as c from '../../../constant';

function BusinessLinesContainer({
  getNewBusinessLinesList,
  newBusinessLinesList,
  newBusinessNaturesId,
  pager,
  formData,
  setFormData,
  ordinanceRevisionId,
}) {
  const setModal = useContext(ModalContext);
  const token = get('token') || '';
  const authProfile = getJson('profile') || {};

  const handleAddBusinessLines = e => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: (
        <CreateModal
          newBusinessNaturesId={newBusinessNaturesId}
          ordinanceRevisionId={ordinanceRevisionId}
        />
      ),
      title: 'Add Business Line',
      modalSize: 'modal-md',
    });
  };

  const handleOnChange = e => {
    setFormData({
      [e.target.name]: e.target.value,
    });
  };

  const handleChangePage = page => {
    getNewBusinessLinesList(newBusinessNaturesId, {
      page,
      ordinance_revision_id: ordinanceRevisionId,
      q: _.get(formData, 'keyword'),
    });
  };

  const onSearch = e => {
    e.preventDefault();
    getNewBusinessLinesList(newBusinessNaturesId, {
      q: _.get(formData, 'keyword'),
      ordinance_revision_id: ordinanceRevisionId,
    });
  };

  const onClearSearch = e => {
    e.preventDefault();
    getNewBusinessLinesList(newBusinessNaturesId, {
      q: ' ',
      ordinance_revision_id: ordinanceRevisionId,
    });
    setFormData({
      keyword: '',
    });
  };

  const handleViewBusinessLinesModal = (id, data) => e => {
    e.preventDefault();

    setModal({
      isOpen: true,
      content: (
        <ViewBusinessLinesModal
          updateList={data.attributes}
          businessLinesId={data.id}
          businessLinesInfo={data}
          ordinanceRevisionId={ordinanceRevisionId}
          newBusinessNaturesId={newBusinessNaturesId}
        />
      ),
      title: 'Business Line Details',
      modalSize: 'modal-lg',
    });
  };

  const srcDownload = `${
    process.env.REACT_APP_WS
  }api/v1/bpls/administrator/report/business_lines/generate_pdf?bearer_token=${token}
  &email=${_.get(
    authProfile,
    'email'
  )}&ordinance_revision_id=${ordinanceRevisionId}`;

  return (
    <div className="row my-3 mx-2">
      <div className="col-12 d-flex justify-content-end mb-3">
        <button
          onClick={handleAddBusinessLines}
          type="button"
          className="btn btn-primary cms-bg-color-primary cms-outline-primary    "
        >
          Add Business Line
        </button>
        <a
          className="btn btn-primary cms-bg-color-primary cms-outline-primary  ml-1   "
          href={srcDownload}
          target="_blank"
          rel="noopener noreferrer"
        >
          <i className="fas fa-print" /> Generate PDF
        </a>
      </div>
      <div className="col-6 d-flex mb-3 form-group">
        <input
          key="keyword"
          name="keyword"
          className="form-control"
          placeholder="Search..."
          type="text"
          onChange={handleOnChange}
          value={_.get(formData, 'keyword') || ''}
        />
        <span className="d-flex align-items-center">
          <button
            className="btn btn-primary cms-bg-color-primary cms-outline-primary  ml-1   "
            onClick={onSearch}
            type="button"
          >
            <i className="fas fa-search icon-search" />
          </button>
          <button
            className="btn btn-danger ml-1"
            onClick={onClearSearch}
            type="button"
          >
            <i className="fas fa-times" />
          </button>
        </span>
      </div>

      <div className="col-12">
        <table className="transaction-table table table-borderless table-sm table-striped table-hover">
          <thead>
            <tr>
              <th>Name</th>
              <th>Code</th>
              <th>License</th>
              <th>Permit</th>
              <th>Sanitary</th>
              <th>Garbage</th>
              <th className="text-center">Actions</th>
            </tr>
          </thead>
          <tbody>
            {newBusinessLinesList && newBusinessLinesList.length <= 0 && (
              <tr className="text-center">
                <td colSpan="7">No data</td>
              </tr>
            )}
            {newBusinessLinesList &&
              newBusinessLinesList.map(item => (
                <tr key={item.id}>
                  <td>{_.get(item, 'attributes.name')}</td>
                  <td>{_.get(item, 'attributes.code')}</td>
                  <td>{_.get(item, 'attributes.license_code')}</td>
                  <td>{_.get(item, 'attributes.permit_code')}</td>
                  <td>{_.get(item, 'attributes.sanitary_code')}</td>
                  <td>{_.get(item, 'attributes.garbage_code')}</td>
                  <td className="text-center">
                    <button
                      onClick={handleViewBusinessLinesModal(
                        newBusinessNaturesId,
                        item
                      )}
                      type="button"
                      className="btn btn-primary cms-bg-color-primary cms-outline-primary    "
                    >
                      View Details
                    </button>
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
      <div className="col-12">
        <div className="d-flex justify-content-center text-center align-item-center">
          <Pagination data={pager} onChange={handleChangePage} />
        </div>
      </div>
    </div>
  );
}

BusinessLinesContainer.propTypes = {
  getNewBusinessLinesList: PropTypes.instanceOf(Function).isRequired,
  newBusinessLinesList: PropTypes.instanceOf(Array).isRequired,
  newBusinessNaturesId: PropTypes.string.isRequired,
  pager: PropTypes.instanceOf(Object).isRequired,
  formData: PropTypes.instanceOf(Object).isRequired,
  setFormData: PropTypes.instanceOf(Function).isRequired,
  ordinanceRevisionId: PropTypes.number.isRequired,
};

const mapStateToProps = ({ api }) => ({
  pager: _.get(api, `${c.GET_NEW_BUSINESS_LINES}.pager`) || {},
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(BusinessLinesContainer);
